import "./App.css";
import logo from './assets/vedlogo.png';
import React, { useEffect } from "react";
import ReactGA from 'react-ga4';
import Input from "./components/Input";
import ShowPredefinedQuestionsQuotes from "./components/QuotesForm";
//import ShowPredefinedQuestionsCallback from "./components/CallbackForm";
import ShowPredefinedQuestionsSupplier from "./components/SupplierFrom";
import useScrollToBottom from "./hooks/useScrollToBottom";
import MenuButton from './components/MenuButton';
import useHandleSetMessage from "./hooks/useHandleSetMessage";
import useAudioRecording from "./hooks/useAudioRecording";
import useFetchProductCookie from "./hooks/useFetchProductCookie";
import useFetchNumberCookie from "./hooks/useFetchNumberCookie";
import useHandleIntent from "./hooks/useHandleIntent";
import useSubmitInput from "./hooks/useSubmitInput";
import useHandleSubmit from "./hooks/useHandleSubmit";
import useHandleMenuOptionSelect from "./hooks/useHandleMenuOptionSelect";
import useFormValidation from "./hooks/useFormValidation";
import useFormSubmission from "./hooks/useFormSubmission";
import { googleTrackingId, chicletOptions } from "./constants";
import { setCookie, processLinks, addGetQuotes } from "./helpers";
import { usePageTracking } from "./components/pageview";
import LoadingDots from './components/LoadingDots';
import { getBaseUrl } from "./utils/request";
import useLocalStorageState from "./hooks/useLocalStorageState"

ReactGA.initialize(googleTrackingId);


//Header for the Chatbot
const Header = () => (
	<div className="header">
        <img src={logo} alt="Logo" className="header-logo" />
		Ved
	</div>
);

//main Chatbot code
function App() {

    //States
	const [input, setInput] = useLocalStorageState('input',"");
	const [messages, setMessages] = useLocalStorageState('messages',[
		{ text: "Hi 👋, I'm Ved here to assist you.\nPlease select any option or let me know your question so that I can help you", tag: "system" },
	]);
	const [formData, setFormData] = useLocalStorageState('formData',{});
	const [showFormQuote, setShowFormQuote] = useLocalStorageState('showFormQuote',false);
	const [showFormSupplier, setShowFormSupplier] = useLocalStorageState('showFormSupplier',false);
	const [productCookie, setProductCookie] = useLocalStorageState('productCookie',"");
	const [numberCookie, setNumberCookie] = useLocalStorageState('numberCookie',"");
	const [isInputDisabled, setIsInputDisabled] = useLocalStorageState('isInputDisabled',false);
	const [sessionId, setSessionId] = useLocalStorageState('sessionId',null);
    const [isMenuDisabled, setIsMenuDisabled] = useLocalStorageState('isMenuDisabled',false);
    const [isLoggedIn, setIsLoggedIn] = useLocalStorageState('isLoggedIn',false);
    const [authToken, setAuthToken] = useLocalStorageState('authToken',"");
    const [organisationId,setOrganisationId] = useLocalStorageState('organisationId',"");
    const [platform, setPlatform] = useLocalStorageState('platform',"");
    const [hideChiclets, setHideChiclets] = useLocalStorageState('hideChiclets',false);

    //hooks
    const scrollToBottom = useScrollToBottom();
    const handleSetMessage = useHandleSetMessage( setMessages );
    const { isRecording, toggleRecording } = useAudioRecording( handleSetMessage, setInput);
    const fetchProductCookie = useFetchProductCookie({sessionId,setProductCookie});
    const fetchNumberCookie = useFetchNumberCookie({setNumberCookie});
    const handleIntent = useHandleIntent({fetchProductCookie,handleSetMessage,scrollToBottom,setShowFormQuote,setShowFormSupplier,setIsInputDisabled,setIsMenuDisabled,setMessages,isLoggedIn});
    const onSubmit = useSubmitInput({input, sessionId, authToken,organisationId});
    const handleSubmit = useHandleSubmit({input,setInput,onSubmit,handleSetMessage,scrollToBottom,handleIntent,setMessages,setIsInputDisabled,setIsMenuDisabled,processLinks,addGetQuotes,setHideChiclets});
    const handleMenuOptionSelect = useHandleMenuOptionSelect({onSubmit,fetchProductCookie,handleSetMessage,scrollToBottom,setShowFormQuote,setShowFormSupplier,setIsInputDisabled,setIsMenuDisabled,setMessages,isLoggedIn,addGetQuotes,setHideChiclets});
    const validateForm = useFormValidation(formData);
    const submitForm = useFormSubmission(authToken, scrollToBottom, handleSetMessage, setFormData, setShowFormQuote, setShowFormSupplier, setIsInputDisabled, setIsMenuDisabled);

    //GAnalytics Page tracking
    usePageTracking();

    /*eslint-disable*/
	useEffect(() => {
        const storedSessionId = JSON.parse(localStorage.getItem("sessionId"));
        if(storedSessionId){
            console.log(sessionId)
        }
        else{
            const newSessionId = 'session-' + Math.random().toString(36).substr(2, 9);
            setSessionId(newSessionId);
            setCookie('sessionId', newSessionId, 1);
        }
        setTimeout(() => {
			scrollToBottom();
		}, 100);    
	}, []);
    /*eslint-enable*/

    useEffect(() => {
        const checkAuthToken = () => {
            const cookies = document.cookie.split('; ');
            const authTokenCookie = cookies.find(cookie => cookie.startsWith('auth-token='));
            if (authTokenCookie) {
                const token = authTokenCookie.split('=')[1];
                setAuthToken(token);
                setIsLoggedIn(true);
            }
        };

        const checkOrgId = () => {
            const cookies = document.cookie.split('; ');
            const orgIdCookie = cookies.find(cookie => cookie.startsWith('organisationId='));
            if (orgIdCookie) {
                const orgId = orgIdCookie.split('=')[1];
                setOrganisationId(orgId);
                setIsLoggedIn(true);
            }
        };

        const checkPlatform = () => {
            const cookies = document.cookie.split('; ');
            const platformCookie = cookies.find(cookie => cookie.startsWith('platform='));
            if(platformCookie){
                setPlatform("App");
            }
        };

        fetchNumberCookie(authToken);
        checkAuthToken();
        checkOrgId();
        checkPlatform();
    }, [setAuthToken,setIsLoggedIn,fetchNumberCookie,authToken,setOrganisationId,setPlatform]);
    
    useEffect(() => {
        const addQuoteButtons = () => {
            const placeholders = document.querySelectorAll('.quote-button-placeholder');
            placeholders.forEach(placeholder => {
                const button = document.createElement('button');
                button.className = 'followUpButton';
                button.innerText = 'Get Quotes';
                button.onclick = () => {
                    handleIntent("give_quotes",input);
                };
                placeholder.parentNode.replaceChild(button, placeholder);
            });
        };
    
        addQuoteButtons();
        /*setTimeout(() => {
			scrollToBottom();
		}, 100);*/
    }, [messages, fetchProductCookie,scrollToBottom,handleIntent,input]);

    const handleChicletClick = (value) => {
        handleMenuOptionSelect(value);
    };
    
    const handleFormSubmitQuotes = async (e) => {
        e.preventDefault();
        if (!validateForm('BUY')) {
          return;
        }
        await submitForm(formData, 'BUY', getBaseUrl()+'/v2/enquiry');
      };
    
    
    const handleFormSubmitSupplier = async (e) => {
        e.preventDefault();
        if (!validateForm('SELL')) {
        return;
        }
        await submitForm(formData, 'SELL', getBaseUrl()+'/v2/enquiry');
    };


    //jsx
	return (
		<div className="App">
			{ platform !== "App" && <Header />}
			<div className="message-container">
				{messages.map((message, index) => (
					<div
						key={index}
						className={`message ${message.tag === 'system' ? 'system-message' : 'user-message'}`}
					>
                        
					{(message.tag === 'system' && message.text.includes('Loading...')) ? (
                    
                            <LoadingDots />
                        ) : message.tag === 'system' ? (
                            <p className="system-call" dangerouslySetInnerHTML={{ __html: message.text }}></p>
                        ) : message.tag === 'user' ? (
                            <p className="user-call">{message.text}</p>
                        ) : (
                            <div>{message.text}</div>
                        )}
					</div>
				))}
                {!hideChiclets && (
                  <div className="chiclet-container">
                    {chicletOptions.map((option) => (
                      <button
                        key={option.value}
                        className="chiclet"
                        onClick={() => handleChicletClick(option.value)}
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                )}
				{showFormQuote && (
					<ShowPredefinedQuestionsQuotes
						setFormData={setFormData}
						setShowFormQuote={setShowFormQuote}
						handleFormSubmit={handleFormSubmitQuotes}
						handleSetMessage={handleSetMessage}
						formData={formData}
						productCookie={productCookie}
						numberCookie={numberCookie}
						setIsInputDisabled={setIsInputDisabled}
                        setIsMenuDisabled={setIsMenuDisabled}
                        setMessages={setMessages}
					/>
				)}
				{showFormSupplier && (
					<ShowPredefinedQuestionsSupplier
						setFormData={setFormData}
						setShowFormSupplier={setShowFormSupplier}
						handleFormSubmit={handleFormSubmitSupplier}
						handleSetMessage={handleSetMessage}
						formData={formData}
						numberCookie={numberCookie}
						setIsInputDisabled={setIsInputDisabled}
                        setIsMenuDisabled={setIsMenuDisabled}
                        productCookie={productCookie}
					/>
				)}
			</div>
			<div className="input-container">
				<MenuButton 
                    onOptionSelect={handleMenuOptionSelect} 
                    isDisabled={isMenuDisabled}
                />
				<Input
					isDisabled={isInputDisabled}
					input={input}
					handleSubmit={handleSubmit}
					setInput={setInput}
                    isRecording={isRecording}
                    toggleRecording={toggleRecording}
				/>
			</div>
		</div>
	);
}

export default App;